import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorage {
  get(key: string): string {
    const found = this.getKeyValues().find((cookie) => key === cookie.key);
    return found ? found.value : '';
  }

  set(key: string, value: string) {
    this.encodeCookie(key, value);
  }

  private getKeyValues() {
    return document.cookie
      .split(';')
      .map((cookie) => this.decodeCookie(cookie));
  }

  private decodeCookie(cookie: any) {
    const fields = cookie.split('=');
    return {
      key: decodeURIComponent(fields[0].trim()),
      value: decodeURIComponent(fields[1].trim())
    };
  }

  private encodeCookie(key: any, value: any) {
    document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; SameSite=None; Secure; Max-Age=3600`;
  }
}
